/** Те же пределы, что проверяет бэкенд (marketingSettings.ts, спека, «Global Constraints»). */
export const FREQUENCY_CAP_COUNT_MIN = 1;
export const FREQUENCY_CAP_COUNT_MAX = 50;
export const FREQUENCY_CAP_DAYS_MIN = 1;
export const FREQUENCY_CAP_DAYS_MAX = 90;

/**
 * Значения enum'а `MarketingConsentModeType` без прямого импорта его самого:
 * тест правит форму сырыми строками, а строковый enum кодогена не даёт
 * присвоить литерал без приведения типа (см. LiveReactionEmojiType и его
 * прямое использование в состоянии карточки: там значения приходят уже
 * типизированными из query, здесь же вводятся формой).
 */
export type MarketingConsentModeValue = "OPT_OUT" | "OPT_IN";

export interface MarketingSettingsFormValues {
  consentMode: MarketingConsentModeValue;
  frequencyCapCount: number;
  frequencyCapDays: number;
}

export type MarketingSettingsFieldError = "capCount" | "capDays";

export const MARKETING_SETTINGS_ERROR_KEYS: Record<
  MarketingSettingsFieldError,
  string
> = {
  capCount: "marketingSettings.errors.capCount",
  capDays: "marketingSettings.errors.capDays",
};

export type MarketingSettingsErrors = Partial<
  Record<"frequencyCapCount" | "frequencyCapDays", string>
>;

/**
 * Границы потолка частоты (Global Constraints фазы): count 1..50, days
 * 1..90. Проверка только этих двух полей: режим согласия ограничен
 * RadioGroup, там нечего валидировать.
 */
export function validateMarketingSettings(
  values: MarketingSettingsFormValues
): MarketingSettingsErrors {
  const errors: MarketingSettingsErrors = {};

  if (
    values.frequencyCapCount < FREQUENCY_CAP_COUNT_MIN ||
    values.frequencyCapCount > FREQUENCY_CAP_COUNT_MAX
  ) {
    errors.frequencyCapCount = MARKETING_SETTINGS_ERROR_KEYS.capCount;
  }

  if (
    values.frequencyCapDays < FREQUENCY_CAP_DAYS_MIN ||
    values.frequencyCapDays > FREQUENCY_CAP_DAYS_MAX
  ) {
    errors.frequencyCapDays = MARKETING_SETTINGS_ERROR_KEYS.capDays;
  }

  return errors;
}

/** Доля использованной квоты в процентах, не больше 100 (спека, полоса прогресса). */
export function quotaPercent(usage: { sent: number; quota: number }): number {
  if (!usage.quota) return 0;
  return Math.min(100, Math.round((usage.sent / usage.quota) * 100));
}
